import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import cn from 'classnames';
import { useSpacingProps } from '../../../../library';
import { IconAlertTriangleFill, IconInfoCircleFill } from '../../../../icons';
import { Tooltip } from '../../../tooltip';
export var fieldClasses = {
  MAIN: 'field',
  LABEL: 'field__label',
  DESCRIPTION: 'field__description',
  ERROR: 'field__error',
  CONTROLS: 'controls',
  CONTROL: 'control',
  HELP: 'field__help'
};
var Label = function Label(props) {
  var className = props.className,
    labelProps = _objectWithoutProperties(props, _excluded);
  return React.createElement("label", _extends({
    className: cn(fieldClasses.LABEL, className)
  }, labelProps), props.children);
};
export var Field = function Field(props) {
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var className = cn(fieldClasses.MAIN, marginClasses, paddingClasses, props.className);
  var renderErrors = function renderErrors() {
    if (!props.errorText) return null;
    var errorArray = Array.isArray(props.errorText) ? props.errorText : [props.errorText];
    return errorArray.filter(function (error) {
      return typeof error === 'string';
    }).map(function (error, index) {
      return React.createElement("span", {
        key: index,
        className: fieldClasses.ERROR
      }, React.createElement(IconAlertTriangleFill, {
        size: "small"
      }), error);
    });
  };
  var renderHelp = function renderHelp() {
    if (!props.helpText) return null;
    return React.createElement(Tooltip, {
      content: props.helpText,
      referenceTagName: "span",
      referenceClassName: fieldClasses.HELP
    }, React.createElement(IconInfoCircleFill, {
      size: "small"
    }));
  };
  return React.createElement("div", {
    className: className
  }, props.label || props.helpText ? React.createElement(Label, {
    htmlFor: props.labelFor
  }, props.label, " ", renderHelp()) : null, props.description && props.descriptionPosition === 'top' ? React.createElement("div", {
    className: fieldClasses.DESCRIPTION
  }, props.description) : null, props.children, props.errorText || props.description && props.descriptionPosition === 'bottom' ? React.createElement("div", {
    className: fieldClasses.DESCRIPTION
  }, renderErrors(), props.description && props.descriptionPosition === 'bottom' ? React.createElement("span", null, props.description) : null) : null);
};
Field.defaultProps = {
  descriptionPosition: 'bottom'
};
Field.Label = Label;